export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8704.cea74627.jpg";